module.exports = __webpack_public_path__ + "img/thirty-years-of-atlantic-hurricanes_sm.jpg";